var $ = require('jquery');

function init() {
	$('.js-auto-submit-on-change').on('change', function() {
		$(this).closest('form').submit();
	});
}

module.exports = {
	init: init
}
